"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenType = void 0;
var TokenType;
(function (TokenType) {
    /**
     * 常规格式
     */
    TokenType["General"] = "G";
    /**
     * 文本格式
     */
    TokenType["Text"] = "t";
    /**
     * 会计格式下文本占位符, 暂不支持
     */
    TokenType["TextPlaceholder"] = "T";
    /**
     * 日期时间格式, 月份
     */
    TokenType["Month"] = "m";
    /**
     * 日期时间格式, 分钟
     */
    TokenType["Minute"] = "M";
    /**
     * 日期时间格式, 天
     */
    TokenType["Day"] = "d";
    /**
     * 日期时间格式, 年
     */
    TokenType["Year"] = "y";
    /**
     * 日期时间格式, 12小时制
     */
    TokenType["HalfDayHours"] = "h";
    /**
     * 日期时间格式, 24小时制
     */
    TokenType["FullDayHours"] = "H";
    /**
     * 日期时间格式, 秒
     */
    TokenType["Second"] = "s";
    /**
     * 日期时间格式, 星期或周
     */
    TokenType["Week"] = "a";
    /**
     * 日期时间格式, 年代
     */
    TokenType["Era"] = "e";
    /**
     * 出现在日期时间格式中不解析, 尚无作用
     */
    TokenType["DatePadding"] = "g";
    /**
     * 日期时间格式, 佛教年
     */
    TokenType["BuddhistYear"] = "b";
    /**
     * 日期时间格式, 绝对时间
     */
    TokenType["AbsoluteTime"] = "Z";
    /**
     * 日期格式, 特殊起始元年
     */
    TokenType["SpecialStartGenesis"] = "X";
    /**
     * 数值类格式
     */
    TokenType["Number"] = "n";
    /**
     * 中文数字格式
     */
    TokenType["ChineseNumber"] = "DN";
    /**
     * 颜色格式
     */
    TokenType["Color"] = "Color";
    /**
     *  数值类格式, 占位符
     */
    TokenType["QuestionMark"] = "?";
    /**
     * 数值类格式, 负数特殊括号
     */
    TokenType["LeftParenthesis"] = "(";
    /**
     * 数值格式, 负数特殊括号
     */
    TokenType["RightParenthesis"] = ")";
    /**
     * 固定数字, 1 - 9 数字字符串
     */
    TokenType["Digit"] = "D";
    /**
     * 空白
     */
    TokenType["Space"] = " ";
    /**
     * 表示已经处理后为空
     */
    TokenType["Empty"] = ";";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
//# sourceMappingURL=core-const.js.map